const resources = {
    pageTitle: 'Ouvrir une session',
    // SIM-2 / ACS-4126 — credential-entry screen
    credentialLabel: 'Téléphone ou adresse courriel',
    credentialPlaceholder: '(123) 456-7890',
    subtitlePrefix: 'Ouvrez une session ou créez un compte pour profiter de l’',
    subtitleBold: 'expédition standard GRATUITE',
    subtitleSuffix: ' sur toutes les commandes.',
    newToSephora: 'Nouveau client Sephora?',
    continueButton: 'Continuer',
    createAccountButton: 'Créer un compte',
    invalidCredential: 'Entrez une adresse courriel ou un numéro de téléphone valides.',
    notFound:
        'Nous n’avons pas trouvé de compte associé à cette adresse courriel ou à ce numéro de téléphone. Vérifiez que les renseignements entrés sont corrects ou créez un compte.',
    closedAccount: 'Ce compte a été fermé. Communiquez avec le service à la clientèle pour obtenir de l’aide.',
    blockedAccount: 'Votre compte nécessite une attention particulière. Communiquez avec le service à la clientèle pour rétablir l’accès.',
    // ERR_400004 - store-registered user with incomplete registration; backend
    // triggers a verification email (same flow as reset-password).
    storeRegistered:
        'Votre compte doit être vérifié. Nous vous avons envoyé un courriel de vérification. Veuillez vérifier votre boîte de réception pour continuer.',
    genericError: 'Un problème est survenu. Veuillez essayer de nouveau dans quelques instants.',
    // SIM-10 / ACS-4134 — cross-cutting states (EN copy per TD-010 until SDL).
    sessionExpired: 'Your session has expired. Please try again.',
    timeoutMessage: 'This is taking longer than expected. Please try again.',
    // EN copy per TD-010 until SDL delivers the FR translation.
    loadingLabel: 'Loading',
    // SIM-7 / ACS-4131 — OTP-first authorization + OTP entry (EN copy per TD-010
    // until SDL delivers FR translations; BR-034: "verification code", never "passcode").
    editLabel: 'Edit',
    editAriaLabel: 'Edit email or phone number',
    authorizationSubtitle: 'How would you like to receive your verification code?',
    smsMethodLabel: 'Text me a verification code',
    emailMethodLabel: 'Email me a verification code',
    passwordMethodLabel: 'Enter password',
    smsConsentPrefix:
        'The information collected here will only be used for verification purposes. Message and data rates may apply. By clicking "Send", you (1) agree to the current version of our ',
    smsConsentTextTerms: 'Text Terms',
    smsConsentMiddle: ', and (2) have read Sephora\'s ',
    smsConsentPrivacy: 'Privacy Policy',
    smsConsentSuffix: '.',
    sendButton: 'Send',
    otpInputAriaLabel: 'Enter 6-digit verification code',
    otpInputBoxAriaLabel: 'Verification code input {0}',
    otpSectionLabelPhone: 'Phone Verification',
    otpSectionLabelEmail: 'Email Verification',
    otpHeadingPhone: 'Check your messages and enter your verification code',
    otpHeadingEmail: 'Check your email and enter your verification code',
    otpSubtitlePrefix: 'You will receive a code at ',
    otpSubtitleSuffix: ' if it is registered with a Beauty Insider account.',
    resendPrefix: 'Didn\'t get ',
    resendChannelPhone: 'the SMS',
    resendChannelEmail: 'an email',
    resendQuestion: '? ',
    resendButton: 'Resend code',
    resendCountdownPrefix: 'Resend code in ',
    resendCountdownSuffix: ' seconds',
    tryAnotherMethodButton: 'Try Another Method',
    otpExpiredOrIncorrect: 'That code has expired or is incorrect. We sent a new verification code to ',
    otpSendFailed: 'We couldn\'t send your verification code. Try a different method.',
    otpLimitMessage: 'Too many attempts. Try a different sign-in method or contact customer service.',
    // SIM-9 / ACS-4133 - inline password + email-confirmation copy (EN copy per
    // TD-010 until SDL delivers the FR translation; BR-034 terminology preserved).
    passwordFieldLabel: 'Password',
    passwordRequired: 'Enter your password.',
    forgotPasswordLink: 'Forgot Password?',
    passwordConsentPrefix: 'By clicking "Sign In", you (1) agree to the current version of our ',
    passwordConsentTerms: 'Terms of Use',
    passwordConsentMiddle: ' and (2) have read Sephora\'s ',
    passwordConsentPrivacy: 'Privacy Policy',
    passwordConsentSuffix: '.',
    signInButton: 'Sign In',
    emailConfirmSubtitle: 'Enter your email address associated with your account.',
    emailConfirmLabel: 'Email Address'
};

// Note: the SMS-consent legal anchor URLs live in the EN locale (SignIn_en_US.js)
// and are imported by AuthorizationScreen from there; they are intentionally NOT
// re-exported here to avoid dead exports.

export default function getResource(label) {
    return resources[label];
}
